
<table *ngIf="hoax" class="table">
  <tbody>
    <tr>
        <td>Body</td>
        <td>
          {{hoax['body']}}
        </td>
    </tr>
    <tr>
        <td>Explanation</td>
        <td>{{hoax['explanation']}}</td>
    </tr>
    <tr>
        <td>Truth</td>
        <td>{{hoax['truth']}}</td>
    </tr>

  </tbody>
</table>


<form  *ngIf="hoax" [formGroup] = "myForm" (ngSubmit)="onSubmit()" class="form" enctype="multipart/form-data">
  <div class="form-group row" [ngClass]="{error:f.factId.errors && f.factId.touched}">
    <label for="factId" class='control-label col-sm-3' >Fact Id</label>
        <div class="input-group controls col-sm-8">
          <input type="textarea" rows="5" id="factId" formControlName="factId" class="form-control">
        </div>
        <div *ngIf="f.factId.errors && f.factId.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
          <ul>
              <li>factId Required.</li>
          </ul>
      </div>
  </div>
  <fieldset class="buttons text-center" *ngIf="!loading">
    <button [disabled]="isSaving" type="submit" class="btn btn-primary">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
        Submit
    </button>
</fieldset>
</form>
